import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { FolderDown, FolderUp } from 'lucide-react';

export default function ExportHistoryTab({ exportHistory, importHistory }) {
  return (
    <>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Historique exports */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <FolderDown className="h-5 w-5 text-indigo-600" />
                  Historique des exports
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {exportHistory.map((item) => (
                    <div key={item.id} className="p-3 border rounded-lg hover:bg-gray-50">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className={`w-2 h-2 rounded-full ${
                            item.status === 'success' ? 'bg-green-500' : 'bg-red-500'
                          }`} />
                          <div>
                            <p className="text-sm font-medium">{item.date}</p>
                            <div className="flex gap-1 mt-1">
                              {item.types.map((t, i) => (
                                <Badge key={i} variant="outline" className="text-xs bg-slate-700 text-white border-slate-800 font-semibold">{t}</Badge>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <Badge className="bg-indigo-700 text-white font-medium">{item.format.toUpperCase()}</Badge>
                          <p className="text-xs text-gray-500 mt-1">{item.size}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Historique imports */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <FolderUp className="h-5 w-5 text-green-600" />
                  Historique des imports
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {importHistory.map((item) => (
                    <div key={item.id} className="p-3 border rounded-lg hover:bg-gray-50">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className={`w-2 h-2 rounded-full ${
                            item.status === 'success' ? 'bg-green-500' : 
                            item.status === 'partial' ? 'bg-yellow-500' : 'bg-red-500'
                          }`} />
                          <div>
                            <p className="text-sm font-medium">{item.date}</p>
                            <div className="flex gap-1 mt-1">
                              {item.types.map((t, i) => (
                                <Badge key={i} variant="outline" className="text-xs bg-slate-700 text-white border-slate-800 font-semibold">{t}</Badge>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="font-medium text-green-700">{item.records} enr.</p>
                          <Badge className={`${
                            item.status === 'success' ? 'bg-green-700' : 
                            item.status === 'partial' ? 'bg-yellow-700' : 'bg-red-700'
                          } text-white font-medium`}>
                            {item.status === 'success' ? 'Complet' : 
                             item.status === 'partial' ? 'Partiel' : 'Échec'}
                          </Badge>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
    </>
  );
}
